import { h, Fragment, Ref } from 'preact';
import { useCoreContext } from '../../../core/Context/CoreProvider';
import { useState } from 'preact/hooks';
import { useAmount } from '../../../core/Context/AmountProvider';

// TODO this should ideally be remove but we need let prop propagate down
//  probably not worth changing this behaviour now
export interface RedirectButtonProps {
    label?: string;
    icon?: string;
    payButton: Function;
    onSubmit: Function;
    name: string;
    showPayButton: boolean;
    ref?: Ref<typeof RedirectButton>;
}

function RedirectButton({ label = null, icon = null, payButton, onSubmit, name, showPayButton, ...props }: Readonly<RedirectButtonProps>) {
    const { i18n } = useCoreContext();
    const [status, setStatus] = useState('ready');
    const { amount } = useAmount();

    this.setStatus = newStatus => {
        setStatus(newStatus);
    };

    const payButtonLabel = () => {
        const isZeroAuth = amount && {}.hasOwnProperty.call(amount, 'value') && amount.value === 0;
        if (isZeroAuth) return `${i18n.get('preauthorizeWith')} ${name}`;
        return `${i18n.get('continueTo')} ${name}`;
    };

    if (!showPayButton) {
        return;
    }

    return (
        <Fragment>
            {payButton({
                ...props,
                status,
                icon,
                classNameModifiers: ['standalone'],
                label: label || payButtonLabel(),
                onClick: onSubmit
            })}
        </Fragment>
    );
}

export default RedirectButton;
